export const Account = {
    "用户名":"用戶名",
    "邮箱/手机号":"郵箱/手機號",
    "请输入您的邮箱/手机号":"請輸入您的郵箱/手機號",
    "请输入要绑定邮箱手机号":"請輸入要綁定郵箱/手機號",
    "请填邮箱/手机号":"請填郵箱/手機號",
    "验证码":"驗證碼",
    "请输入验证码":"請輸入驗證碼",
    "请输入计算结果":"請輸入計算結果",
    "提交":"提交",
    "请输入密码":"請輸入密碼",
    "请填写密码":"請填寫密碼",
    "确认密码":"確認密碼",
    "请再次输入":"請再次輸入",
    "两次输入的密码不一致请您检查密码":"兩次輸入的密碼不壹致，請您檢查密碼",
    "已发送验证码至":"已發送驗證碼至",
    "注册并登陆":"註冊並登陸",
    "账号类型错误":"賬號類型錯誤",
    "邮箱账号手机号":"郵箱/賬號/手機號",
    "请输入邮箱手机号":"請輸入郵箱/手機號",
    "还没有账号":"還沒有賬號？",
    "立即注册并绑定":"立即註冊並綁定",
    "注册并绑定":"註冊並綁定",
    "请检查登录信息":"請檢查登錄信息",
    "没有读取到code_key":"没有讀取到code_key",
    "登录失败":"登錄失敗",
    "请检查密码格式应大于6位":"請檢查密碼格式，應大於6位",
    "两次密码应该相同":"兩次密碼應該相同",
    "请检查账号格式":"請檢查賬號格式",
    "绑定账号":"綁定賬號",
    "请输入右侧图片验证码":"請輸入右側圖片驗證碼",
    "短信":"短信",
    "邮箱或短信验证码":"郵箱或短信驗證碼",
    "确认重置密码":"確認重置密碼",
    "验证":"驗證",
    "找回密码":"找回密碼",
    "发送验证码失败账户类型不对":"發送驗證碼失敗，賬戶類型不對",
    "重置密码":"重置密碼",
    "密码修改成功请前去登陆":"密碼修改成功，請前去登陸",
    "账号密码登录":"賬號密碼登錄",
    "快速注册登录":"快速註冊/登錄",
    "请输入手机号":"請輸入手機號",
    "请输入短信验证码":"請輸入短信驗證碼",
    "获取验证码":"獲取驗證碼",
    "请输入账号手机邮箱":"請輸入賬號/手機/郵箱",
    "忘记密码":"忘記密碼",
    "没有账号":"沒有賬號?",
    "去注册":"去註冊?",
    "微信登录":"微信登錄",
    "注册登录":"註冊/登錄",
    "登录":"登錄",
    "请输入用户名":"請輸入用戶名",
    "请输入6位以上密码":"請輸入6位以上密碼",
    "邮箱验证":"郵箱驗證",
    "短信验证":"短信驗證",
    "类型错误":"類型錯誤",
    "正在登录中":"正在登錄中...",
    "请输入正确格式的账号":"請輸入正確格式的賬號",
    "密码强度过低":"密碼強度過低",
    "选择身份":"選擇身份",
    "请输入或者选择学校":"請輸入或者選擇學校",
    "立即注册":"立即註冊",
    "添加老师助教":"添加老師/助教",
    "老师助教":"老師/助教",
    "请输入课堂派账号手机邮箱":"請輸入課堂派賬號/手機/郵箱",
    "添加老师助教成功":"添加老師/助教成功",
    "全部学生":"全部學生",
    "按标签":"按標簽",
    "机构选课名单":"機構選課名單",
    "新建标签":"新建標簽",
    "删除成员":"删除成員",
}